import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { motion } from "framer-motion";

const testimonials = [
  {
    name: "Mr Johnson",
    role: "CEO, Creative Studio",
    feedback:
      "Working with Tariq was an absolute pleasure. His attention to detail and creative solutions helped us launch our website on time with flawless.",
    img: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    name: "Chaudhary Abdul Rehman",
    role: "Owner of Vehicle Spare Parts",
    feedback:
      "Tariq combines technical expertise with great communication. He quickly understood our requirements and delivered beyond expectations.",
    img: "https://www.phoneworld.com.pk/wp-content/uploads/2020/09/USF.jpg",
  },
  {
    name: "Ayesha Khan",
    role: "Entrepreneur",
    feedback:
      "Professional, reliable, and innovative — Tariq helped me transform my business idea into a beautiful online presence. Highly recommended!",
    img: "https://www.gre.ac.uk/__data/assets/image/0030/321888/zahra-khan-fes-june-2023.jpg",
  },
];

const Testimonials = () => {
  return (
    <section
      className="py-5 text-white"
      style={{
        background: "linear-gradient(135deg, #0d0d0d, #1e1e1e)",
      }}
    >
      <Container>
        {/* Title */}
        <motion.h2
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-3 fw-bold"
          style={{
            fontSize: "2.5rem",
            background: "linear-gradient(90deg, #0d6efd, #6f42c1)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          What Clients Say
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center text-light-emphasis mb-5"
        >
          Trusted by professionals and businesses worldwide.
        </motion.p>

        <Row className="g-4">
          {testimonials.map((t, index) => (
            <Col md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                <motion.div
                  whileHover={{ scale: 1.05, rotate: 1 }}
                  transition={{ type: "spring", stiffness: 200 }}
                >
                  <Card
                    className="shadow-lg border-0 h-100 text-center p-3"
                    style={{
                      background:
                        "linear-gradient(145deg, rgba(28,28,28,0.8), rgba(42,42,42,0.9))",
                      color: "#fff",
                      borderRadius: "20px",
                      backdropFilter: "blur(10px)",
                      boxShadow: "0 8px 25px rgba(0,0,0,0.4)",
                      transition: "all 0.3s ease-in-out",
                    }}
                  >
                    <motion.img
                      src={t.img}
                      alt={t.name}
                      className="rounded-circle mx-auto mt-3"
                      style={{
                        width: "90px",
                        height: "90px",
                        border: "4px solid #6f42c1",
                        boxShadow: "0 0 15px rgba(111,66,193,0.6)",
                      }}
                      whileHover={{ scale: 1.1, rotate: 5 }}
                      transition={{ type: "spring", stiffness: 150 }}
                    />
                    <Card.Body>
                      <Card.Text
                        className="fst-italic text-light-emphasis"
                        style={{ fontSize: "0.95rem", lineHeight: "1.6" }}
                      >
                        "{t.feedback}"
                      </Card.Text>
                      <h5 className="fw-semibold mt-3">{t.name}</h5>
                      <small
                        className="text-secondary"
                        style={{ fontSize: "0.85rem" }}
                      >
                        {t.role}
                      </small>
                    </Card.Body>
                  </Card>
                </motion.div>
              </motion.div>
            </Col>
          ))}
        </Row>

        {/* Call to Action */}
        <motion.div
          className="text-center mt-5"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.8, duration: 0.6 }}
          viewport={{ once: true }}
        >
          <motion.a
            href="https://wa.me/923325293542?text=Hello!%20I%20visited%20your%20portfolio."
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{
              scale: 1.1,
              boxShadow: "0px 0px 20px rgba(13,110,253,0.7)",
            }}
            style={{
              display: "inline-block",
              background: "linear-gradient(90deg, #0d6efd, #6f42c1)",
              padding: "12px 28px",
              borderRadius: "30px",
              color: "#fff",
              fontWeight: "600",
              textDecoration: "none",
              transition: "all 0.3s ease-in-out",
            }}
          >
            Let’s Work Together
          </motion.a>
        </motion.div>
      </Container>
    </section>
  );
};

export default Testimonials;
